<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 col-12">
        <span class="text-warning" style="font-size: 25px">قرارداد</span>
        <h5>{{ ContractParent.CustomerName }}</h5>
      </div>
      <div class="col-md-3 col-12 text-right">
        <div class="mt-1">
          نوع قرارداد : <span>{{ ContractParent.NameGrpId12 }}</span>
        </div>
        <div class="mt-1">وضعیت قرارداد : {{ ContractParent.NameGrpId39 }}</div>
        <div class="mt-1">{{ ContractParent.ContractStartDate }} ---- {{ ContractParent.ContractEndDate }}</div>
      </div>
      <div class="col-md-3 col-12 text-center">
        <div class="mt-1">مبلغ قرارداد : {{ $Comma3ragham(ContractParent.Amount) }} ریال</div>
        <div class="mt-1">مبلغ تخفیف : {{ $Comma3ragham(ContractParent.Discount) }} ریال</div>
        <div class="mt-1 text-center">
          <span class="text-warning" style="font-size: 20px">{{ $Comma3ragham(ContractParent.TotallAmount) }}</span>
        </div>
        <div class="mt-1 text-center">
          <!-- <span v-if="Detail.Remember>0" class="text-danger">{{$Comma3ragham(Detail.Remember)}} بدهکار</span> -->
        </div>
        <!-- <div class="mt-1 text-center">
              <div class="rubber_stamp" v-if="Detail.Remember == 0">تسویه شد</div>
            </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <BnpGrid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="rows" :action="true">
          <template slot="action-slot" slot-scope="props">
            <!-- <a href="javascript:;" class="mr-2 badge" v-if="IsAccessDelete || $session.get('UserInfo').tblGrpId == 1" @click="OnEditProduct(props.props)" data-title="ویرایش"
              ><h5><span class="fa fa-pencil-square-o hover-info"></span></h5
            ></a> -->
            <a href="javascript:;" class="mr-2 badge" v-if="IsAccessDelete || $session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245" @click="OnDeleteProduct(props.props)" data-title="حذف"
              ><h5><span class="fad fa-trash hover-danger"></span></h5
            ></a>
          </template>
          <template slot="MetaSlot" slot-scope="props">
            <button class="btn btn-primary text-center mb-2" dir="ltr" v-if="IsAccessSetDeposit" @click.prevent="SetDeposit(props.props)">ثبت واریز <span class="fad fa-plus mx-2"></span></button>
          </template>
          <template slot="TotallAmount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.TotallAmount) }}</span>
          </template>
          <template slot="Discount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.Discount) }}</span>
          </template>
          <template slot="Amount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.Amount) }}</span>
          </template>
          <template slot="Tax" slot-scope="props">
            <span>{{ $Comma3ragham(Number(props.props.Toll) + Number(props.props.Tax)) }}</span>
          </template>
        </BnpGrid>
      </div>
    </div>
  </div>
</template>
<script>
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'
import Num2persian from 'num2persian'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import CardBox from '@/components/CardBox/CardBox.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '../../Modal/Modal.vue'
export default {
  data() {
    return {
      IsRasmi: false,
      ContractParent: {},
      DataAxios: {},
      DataAxiosProductnew: {
        Id: 1,
        Count: 1,
        DataAxiosProduct: 0,
        Discount: 0,
        Tax: 0,
        TotallAmount: 0,
        Toll: 0,
      },
      Disable: false,
      DataAxiosProduct: {},

      AddModeProduct: 0,
      AddModeContract: 0,

      TotallAmountProduct: 0,
      listProduct: [],
      rows: [],
      Column: [
        {
          id: 204443,
          name: 'CustomerName',
          visibility: false,
          width: 0,
          indexCol: 3,
          label: 'نام مشتری',
        },
        {
          id: 204446,
          name: 'DateTimeInsert',
          visibility: true,
          width: 0,
          indexCol: 9,
          label: 'زمان ایجاد',
        },
        {
          id: 204473,
          name: 'Name',
          visibility: true,
          width: 0,
          indexCol: 9,
          label: 'محصول',
        },
        {
          id: 204474,
          name: 'ContractStartDate',
          visibility: true,
          width: 0,
          indexCol: 9,
          label: 'شروع قرارداد',
        },
        {
          id: 204475,
          name: 'ContractEndDate',
          visibility: true,
          width: 0,
          indexCol: 9,
          label: 'پایان قرارداد',
        },
        {
          id: 204473,
          name: 'Count',
          visibility: true,
          width: 0,
          indexCol: 15,
          label: 'تعداد',
        },
        {
          id: 204467,
          name: 'Amount',
          visibility: true,
          width: 0,
          indexCol: 10,
          label: 'مبلغ قرارداد',
        },
        {
          id: 204469,
          name: 'Tax',
          visibility: true,
          width: 0,
          indexCol: 12,
          label: 'مالیات و عوارض',
        },
        {
          id: 204470,
          name: 'Toll',
          visibility: false,
          width: 0,
          indexCol: 13,
          label: 'عوارض',
        },
        {
          id: 204468,
          name: 'Discount',
          visibility: true,
          width: 0,
          indexCol: 11,
          label: 'تخفیف',
        },
        {
          id: 204471,
          name: 'TotallAmount',
          visibility: true,
          width: 0,
          indexCol: 14,
          label: 'کل مبلغ قرارداد',
        },
        {
          id: 204472,
          name: 'NameGrpId12',
          visibility: false,
          width: 0,
          indexCol: 15,
          label: 'نوع',
        },
      ],
      elmAccess: [],
      // sumTotall:0,
      // DataAxiosNew:{},
      Detail: [],
      ErrList: [],
      EditProduct: false,
      DataAxiosEditProduct: {},
      NameProductForEdit: '',
    }
  },
  components: {
    SearchableCombo,
    BtnEditData,
    CardBox,
    BnpGrid,
    Modal,
  },
  computed: {
    Mab2persian() {
      return Num2persian(this.DataAxios.TotallAmount + '')
    },
  },
  methods: {
    EditRow() {
      if (this.$ValidForm('DetailCustomerProductEdit')) {
        this.DataAxiosEditProduct.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
        let DataAxios_DeleteData = {
          ArryfildValue: this.DataAxiosEditProduct,
          Method: 'post',
          Action: 'CustomerProduct/EditProductOfContract',
        }
        this.$PostData(DataAxios_DeleteData)
          .then((data) => {
            if (data.status == 'Ok') {
              this.$store.state.Modal = false
              this.$mySweetDefaultTost('عملیات موفق', 'ویرایش با موفقیت انجام شد', 'success', 2000)

              let find = this.rows.find((x) => x.Id == this.DataAxiosEditProduct.Id)

              find.Count = this.DataAxiosEditProduct.Count
              find.Amount = this.DataAxiosEditProduct.Amount
              find.Discount = this.DataAxiosEditProduct.Discount
              find.Tax = this.DataAxiosEditProduct.Tax
              find.Toll = this.DataAxiosEditProduct.Toll
              find.NeedSubmit = this.DataAxiosEditProduct.NeedSubmit
              find.TotallAmount = this.DataAxiosEditProduct.TotallAmount

              let DataAxios_GetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerProduct/GetProductOfContract', Token: this.$session.get('Token') }
              DataAxios_GetData.ArryfildValue.Id = this.ContractParent.id
              this.$PostData(DataAxios_GetData)
                .then((data) => {
                  this.rows = data
                  this.DataAxiosProduct.TblCustomerId = this.TblContract.TblCustomerId
                  this.$SetLog(this.DataAxiosEditProduct, 0, 0, 'CustomerProduct', 'محصولات قرارداد')
                })
                .finally(() => {
                  this.$store.state.renderComponentGrid = false
                  this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                  })
                })
            } else {
              this.$mySweetDefaultTost('', 'ویرایش با مشکل مواجه شد', 'info', 2000)
            }
          })
          .catch((err) => {
            console.error('CATCH', err)
            if (userIdInsert == this.userId) {
              this.$mySweetDefaultTost('عملیات ناموفق', 'ارسال پیام با خطا مواجه شد', 'error', 2000)
              this.isSendingMesssage = false
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
      }
    },
    FocusOutAmountProductEdit(e) {
      let amount = String(this.DataAxiosEditProduct.Amount)
      var AmountProduct = Number(amount.replace(/,/g, ''))
      let discount = String(this.DataAxiosEditProduct.Discount)
      var DiscountProduct = Number(discount != '0' ? discount.replace(/,/g, '') : 0)

      if (DiscountProduct >= AmountProduct * this.DataAxiosEditProduct.Count) {
        this.$mySweetDefault('خطای عملیاتی', 'مبلغ تخفیف نمیتواند بیشتر از مبلغ محصول باشد', 'warning', 1500)
        this.ErrList = ['مبلغ تخفیف وارد شده بیشتر از حد مجاز می باشد ، لطفا اصلاح نمایید و دوباره تلاش کنید']
        this.$PutCommatoInput()

        return
      } else {
        this.ErrList = []
        var mabKol = AmountProduct * Number(this.DataAxiosEditProduct.Count) - DiscountProduct
        this.DataAxiosEditProduct.Tax = this.$Comma3ragham(Math.ceil(Number(mabKol) * 0.07))
        this.DataAxiosEditProduct.Toll = this.$Comma3ragham(Math.ceil(Number(mabKol) * 0.03))

        this.DataAxiosEditProduct.TotallAmount = this.$Comma3ragham(mabKol + Number(this.DataAxiosEditProduct.Tax.replace(/,/g, '')) + Number(this.DataAxiosEditProduct.Toll.replace(/,/g, '')))
      }
    },
    DeleteProduct(tblProductsId) {
      // console.log(this.IsRasmi)
      if (this.IsRasmi == true) {
        this.$toasted.error('بعد از ثبت نهایی امکان حذف محصولات قرارداد وجود ندارد', { duration: 2000 })
      } else {
        for (let index = 0; index < this.listProduct.length; index++) {
          if (this.listProduct[index].TblProductsId == tblProductsId) {
            this.listProduct.splice(index, 1)
          }
        }
      }
    },
    GetResulTblCostomer(data) {
      this.DataAxios.TblCustomerId = data.id
    },
    GetResulTblCostomerProduct(data) {
      this.DataAxiosProduct['TblCustomerId'] = data.id
    },
    GetResulProductsId(data) {
      this.DataAxios.TblProductsId = data.id
    },
    GetResulGrpId39(data) {
      this.DataAxios.TblComboGrpId39 = 1786
    },
    GetResulTblProductsId(data) {
      this.DataAxiosProduct['ProductName'] = data.name
      this.DataAxiosProduct['TblProductsId'] = data.id
    },
    AddRow(mode) {
      if (this.$ValidForm('DetailCustomerProductRow')) {
        if (mode == false) {
          if (this.rows.length == 0) {
            window.addEventListener('keydown', this.GetKeyUp)
            let SumProduct = 0
            var findItem = false
            for (let index = 0; index < this.listProduct.length; index++) {
              if (this.listProduct[index].TblProductsId == this.DataAxiosProduct.TblProductsId) {
                findItem = true
                SumProduct = SumProduct + this.listProduct[index].TotallAmount
              }
            }
            SumProduct = this.DataAxiosProduct.TotallAmount
            if (findItem == false) {
              if (this.TblContract && Number(SumProduct.replace(/,/g, '')) < Number(this.TblContract.TotallAmount)) {
                //رسمی
                this.DataAxiosProduct.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                this.listProduct.push(JSON.parse(JSON.stringify(this.DataAxiosProduct)))
                this.$mySweetDefaultTost('عملیات موفق', 'آیتم مورد نظر شما به لیست محصولات اضافه گردید ', 'success', 1000)
                this.ReloadProduct()
                this.AddModeProduct = 0
                return
              } else if (!this.TblContract) {
                //غیر رسمی
                this.DataAxiosProduct.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                this.listProduct.push(JSON.parse(JSON.stringify(this.DataAxiosProduct)))
                this.$mySweetDefaultTost('عملیات موفق', 'آیتم مورد نظر شما به لیست محصولات اضافه گردید ', 'success', 1000)
                this.ReloadProduct()
                this.AddModeProduct = 0
                return
              } else {
                this.$mySweetDefaultTost('عملیات ناموفق', 'جمع مبالغ محصولات با جمع مبلغ قرارداد یکسان نمی باشد', 'success', 1000)
                return
              }
            } else {
              this.$mySweetDefault('عملیات ناموفق', 'آیتم مورد نظر شما در لیست محصولات وجود دارد', 'error', 1500)
              return
            }
          } else {
            this.$mySweetDefault('خطای عملیاتی', 'امکان اضافه کردن محصول جدید به قراردادی که قبلا ثبت کامل شده امکان پذیر نمی باشد ، لطفا در قرارداد جدید محصول خودرا اضافه کنید', 'error', 6000)
          }
        }
      }
    },
    ReloadProduct() {
      // this.DataAxiosProduct={}
      var temp = JSON.parse(JSON.stringify(this.DataAxiosProduct.TblCustomerId))
      this.DataAxiosProduct = JSON.parse(JSON.stringify(this.DataAxiosProductnew))
      this.DataAxiosProduct.TblCustomerId = temp
    },
    FocusOutAmountProduct(e) {
      var AmountProduct = Number(this.DataAxiosProduct.Amount.replace(/,/g, ''))
      var DiscountProduct = Number(this.DataAxiosProduct.Discount != '0' ? this.DataAxiosProduct.Discount.replace(/,/g, '') : 0)

      if (DiscountProduct >= AmountProduct * this.DataAxiosProduct.Count) {
        this.$mySweetDefault('خطای عملیاتی', 'مبلغ تخفیف نمیتواند بیشتر از مبلغ محصول باشد', 'warning', 1500)
        this.ErrList = ['مبلغ تخفیف وارد شده بیشتر از حد مجاز می باشد ، لطفا اصلاح نمایید و دوباره تلاش کنید']
        this.$PutCommatoInput()

        return
      } else {
        this.ErrList = []
        var mabKol = AmountProduct * Number(this.DataAxiosProduct.Count) - DiscountProduct
        this.DataAxiosProduct.Tax = this.$Comma3ragham(Math.ceil(Number(mabKol) * 0.07))
        this.DataAxiosProduct.Toll = this.$Comma3ragham(Math.ceil(Number(mabKol) * 0.03))

        this.DataAxiosProduct.TotallAmount = this.$Comma3ragham(mabKol + Number(this.DataAxiosProduct.Tax.replace(/,/g, '')) + Number(this.DataAxiosProduct.Toll.replace(/,/g, '')))
      }
    },
    FocusOutAmount(e) {
      var Amount = Number(this.DataAxios.Amount.replace(/,/g, ''))
      var Discount = Number(this.DataAxios.Discount != '0' ? this.DataAxios.Discount.replace(/,/g, '') : 0)
      if (Discount >= Amount) {
        this.$mySweetDefault('خطای عملیاتی', 'مبلغ تخفیف نمیتواند بیشتر از مبلغ محصول باشد', 'warning', 1500)
        return
      } else {
        var mabKol = Amount - Discount
        this.DataAxios.Tax = this.$Comma3ragham(Number(mabKol) * 0.07)
        this.DataAxios.Toll = this.$Comma3ragham(Number(mabKol) * 0.03)
        this.DataAxios.TotallAmount = this.$Comma3ragham(mabKol + Number(this.DataAxios.Tax.replace(/,/g, '')) + Number(this.DataAxios.Toll.replace(/,/g, '')))
      }
    },
    CheckLenghtDiscount(e, IsProduct) {
      if (IsProduct == true) {
        if (e.target.value.length < 4 && e.target.value.length > 0) {
          this.DataAxiosProduct.DiscountProduct = 0
          this.FocusOutAmountProduct()
        }
      }
      if (IsProduct == false) {
        if (e.target.value.length < 4 && e.target.value.length > 0) {
          this.DataAxios.Discount = 0
          this.FocusOutAmount()
        }
      }
    },

    submitProduct() {
      var Contract = {
        Id: 1,
        TblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
        TblComboGrpId12: 1227,
        TblCustomerId: this.listProduct[0].TblCustomerId,
        ContractStartDate: '',
        ContractEndDate: '',
        TblComboGrpId39: 1787,
        Amount: 0,
        Discount: 0,
        Tax: 0,
        Toll: 0,
        TotallAmount: 0,
      }
      if (this.TblContract != null) {
        Contract = this.TblContract
      }
      Contract['TblCustomerProducts'] = this.listProduct
      var DataAxios_Post = { Action: 'CustomerProduct', Method: 'Post', Token: this.$session.get('Token'), ArryfildValue: {} }
      DataAxios_Post.ArryfildValue = Contract
      this.$PostData(DataAxios_Post)
        .then((result) => {
          if (result.status == 'Ok') {
            this.$mySweetDefaultTost('عملیات موفق', 'محصول جدید با موفقیت ثبت شد', 'success', 3000)
            this.$router.push({ name: 'Contract', params: { TblCustomerId: this.listProduct[0].TblCustomerId } })
            this.listProduct = []
          }
        })
        .finally(() => {})
    },

    submitProductContract(isRasmi) {
      let SumAmount = 0
      let SumDiscount = 0
      let SumToll = 0
      let SumTax = 0
      let SumTotall = 0
      let TblCustomerId = null
      this.listProduct.forEach((e) => {
        SumAmount = +SumAmount + Number(e.Amount.replace(/,/g, '')) * e.Count
        e.Discount = e.Discount + ''
        SumDiscount = +SumDiscount + Number(e.Discount.replace(/,/g, ''))
        SumToll = +SumToll + Number(e.Toll.replace(/,/g, ''))
        SumTax = +SumTax + Number(e.Tax.replace(/,/g, ''))
        SumTotall = +SumTotall + Number(e.TotallAmount.replace(/,/g, ''))
        TblCustomerId = e.TblCustomerId
      })
      var Contract = {
        Id: 1,
        TblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
        TblComboGrpId12: isRasmi ? 1226 : 1227,
        TblCustomerId: TblCustomerId,
        ContractStartDate: '',
        ContractEndDate: '',
        TblComboGrpId39: 1787,
        Amount: this.$Comma3ragham(SumAmount),
        Discount: this.$Comma3ragham(SumDiscount),
        Tax: isRasmi ? this.$Comma3ragham(SumTax) : 0,
        Toll: isRasmi ? this.$Comma3ragham(SumToll) : 0,
        TotallAmount: isRasmi ? this.$Comma3ragham(SumTotall) : this.$Comma3ragham(SumAmount - SumDiscount),
      }
      this.DataAxios = Contract
      this.IsRasmi = true
      this.AddModeContract = 1
      this.Disable = true
    },
    SetContrctAndProducts() {
      if (this.DataAxios.ContractStartDate == this.DataAxios.ContractEndDate) {
        this.$mySweetDefaultTost('عملیات ناموفق', 'تاریخ شروع و پایان قرارداد نمیتواند یکسان باشد. ', 'warning', 1000)
        return 0
      }
      if (this.$ValidForm('DivContract')) {
        this.DataAxios['TblCustomerProducts'] = this.listProduct
        var DataAxios_Post = { Action: 'CustomerProduct', Method: 'Post', Token: this.$session.get('Token'), ArryfildValue: {} }
        this.DataAxios.TblComboGrpId39 = 1786
        if (this.TblCustomerId) {
          this.DataAxios.Id = this.TblContract.Id
        }
        DataAxios_Post.ArryfildValue = this.DataAxios
        this.$PostData(DataAxios_Post)
          .then((result) => {
            if (result.status == 'Ok') {
              this.$toasted.success('ثبت قرارداد با موفقیت انجام شد .', {
                duration: 3000,
              })
              // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: this.listProduct[0].TblCustomerId, activeTab: 9 } })
              this.$FindeCustomerById('DetailCustomer',this.listProduct[0].TblCustomerId,9,null)
              this.listProduct = []
              this.IsRasmi = false
            }
          })
          .finally(() => {})
      }
    },

    GotoContract(TblCustomerId) {
      if (this.IsCartableContract) this.$router.push({ name: 'CartableContract' })
      else this.$router.push({ name: 'Contract', params: { TblCustomerId: TblCustomerId } })
    },

    OnEditProduct(row) {
      this.NameProductForEdit = row.Name
      this.DataAxiosEditProduct.Id = row.Id
      this.DataAxiosEditProduct.Count = row.Count
      this.DataAxiosEditProduct.Amount = row.Amount
      this.DataAxiosEditProduct.Discount = row.Discount
      this.DataAxiosEditProduct.Tax = row.Tax
      this.DataAxiosEditProduct.TotallAmount = row.TotallAmount
      this.DataAxiosEditProduct.Toll = row.Toll
      this.DataAxiosEditProduct.NeedSubmit = row.NeedSubmit
      this.DataAxiosEditProduct.TblContractId = row.TblContractId

      this.$store.state.Modal = true
      let find = this.rows.find((x) => x.Id == row.Id)
      this.$store.state.OldDataForLog = JSON.stringify(find)
    },
    OnDeleteProduct(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row)
      let DataAxios_DeleteData = {
        ArryfildValue: row,
        Method: 'delete',
        Action: 'CustomerProduct',
        Token: this.$session.get('Token'),
      }
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف محصول ' + row.Name + ' ؟',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$PostData(DataAxios_DeleteData)
              .then((data) => {
                if (data.status == 'Ok') {
                  let DataAxios_GetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerProduct/GetProductOfContract', Token: this.$session.get('Token') }
                  DataAxios_GetData.ArryfildValue.Id = this.ContractParent.id
                  this.$PostData(DataAxios_GetData)
                    .then((data) => {
                      this.rows = data
                      this.DataAxiosProduct.TblCustomerId = this.TblContract.TblCustomerId
                      this.$SetLog(DataAxios_DeleteData.ArryfildValue, 1, 0, 'CustomerProduct', 'محصولات قرارداد')
                    })
                    .finally(() => {
                      this.$store.state.renderComponentGrid = false
                      this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                      })
                    })
                } else {
                  if (data.eNum == 547) {
                    this.$mySweetDefaultTost('عملیات ناموفق', 'امکان حذف محصول فروخته شده به دلیل  وجود سند واریزی برای این محصول امکان پذیر نمی باشد', 'warning', 5000)
                  }
                }
              })
              .finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true
                })
              })
          }
        })
    },
    GetKeyUp(e) {
      if (e.which === 114) {
        e.preventDefault() //prevent browser from the default behavior
        if (this.IsAccess('btnSetContract!Rasmi')) {
          this.submitProductContract(false)
        }
      }
    },

    GetAccessUser() {
      var menu = this.$session.get('Menu')
      var IdMenu = menu.find((x) => x.RouteName == this.$route.name).id
      this.elmAccess = menu.filter((x) => x.ParentId == IdMenu)
    },
    IsAccess(elmId) {
      let IsExist = false
      this.elmAccess.forEach((element) => {
        if (element.ControlName == elmId) {
          if (element.isMojaz == 1) {
            IsExist = true
          }
        }
      })
      return IsExist
    },

    CalcBedehiCustomer(TblCustomerId) {
      this.$CalcBedehiCustomer(TblCustomerId).then((result) => {
        this.Detail = result[0]
      })
    },
    SetDeposit() {
      this.$router.push({ name: 'Deposit', params: { Status: 'Add', TblCustomerId: this.ContractParent.TblCustomerId } })
    },
  },
  mounted() {
    this.GetAccessUser()
    this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
    this.DataAxios.TblComboGrpId12 = 1226
  },
  created() {
    this.DataAxiosProduct = JSON.parse(JSON.stringify(this.DataAxiosProductnew))
    if (this.$route.params.Status == 'Add') {
      this.ContractParent = this.TblContract
      if (this.TblCustomerId) {
        this.DataAxiosProduct.TblCustomerId = this.TblCustomerId
        this.AddModeProduct = 1
        this.DataAxios = this.TblContract
      }
    }
    if (this.Status == 'Product') {
      this.IsRasmi = false
      this.ContractParent = this.TblContract
      let DataAxios_GetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerProduct/GetProductOfContract', Token: this.$session.get('Token') }
      DataAxios_GetData.ArryfildValue.Id = this.ContractParent.id ? this.ContractParent.id : this.ContractParent.Id
      this.$PostData(DataAxios_GetData)
        .then((data) => {
          this.rows = data
          this.DataAxiosProduct.TblCustomerId = this.TblContract.TblCustomerId
          this.CalcBedehiCustomer(this.TblContract.TblCustomerId)
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    }
    if (this.$route.params.Status == 'Edit') {
      this.DataAxios = this.TblContract
      this.DataAxios.Amount = this.$Comma3ragham(this.TblContract.Amount)
      this.DataAxios.Toll = this.$Comma3ragham(this.TblContract.Toll)
      this.DataAxios.TotallAmount = this.$Comma3ragham(this.TblContract.TotallAmount)
      this.DataAxios.Tax = this.$Comma3ragham(this.TblContract.Tax)
      this.DataAxios.Discount = this.$Comma3ragham(this.TblContract.Discount)
      this.AddModeContract = 1
      this.IsRasmi = true
      this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
    }
  },
  props: ['TblContract', 'IsAccessDelete', 'IsAccessSetDeposit', 'TblCustomerId', 'IsCartableContract', 'Status'],
  updated() {
    this.$PutCommatoInput()
  },
}
</script>
